import { dotationImageSx } from '../../../SingleRequestPage/components/SingleRequestDrawer/styles/styles'

export const getCheckboxSx = (
  indeterminate: boolean,
  checked: boolean,
  isDistricts: boolean,
) => ({
  width: '18px',
  height: '16px',
  color: indeterminate
    ? '#7091B7!important'
    : checked
      ? 'rgba(3, 72, 126, 1)!important'
      : undefined,
  border: indeterminate
    ? '1px solid rgba(2, 58, 102, 1)!important'
    : '1px solid transparent!important',
  borderRadius: indeterminate ? '2px!important' : undefined,
  svg: {
    width: indeterminate && !isDistricts ? '19.75px' : '23px',
    height: indeterminate ? '19.75px' : '22px',
    position: 'absolute',
    top: '-3px',
    left: indeterminate && !isDistricts ? '-3px' : '-4px',
  },
})

export const getTreeItemContentSx = (
  id: string,
  secondId: string | null,
  isChild?: boolean,
) => ({
  backgroundColor:
    id === secondId && !isChild
      ? '#5DAFEF33!important'
      : 'transparent!important',
  '&:hover': {
    backgroundColor: '#5DAFEF33!important',
  },
})

export const treeItemRootSx = {
  color: 'black',
  li: {
    borderRadius: '8px',
    ul: {
      paddingLeft: '45px',
      paddingRight: '16px',
    },
  },
  'li:nth-child(odd)': {
    backgroundColor: '#fff!important',
  },
  'li:nth-child(even)': {
    backgroundColor: '#F6F6F6!important',
  },
}

export const fullDotationSx = { ...dotationImageSx, top: '20%', right: '20px' }

export const richTreeSx = {
  ul: {
    paddingLeft: '22px',
    paddingRight: '16px',
  },
}
